import React from "react";
import AppStore from "../../assets/application/applogo.png";
import PlayStore from "../../assets/application/googleplay.png";
import AppGallery from "../../assets/application/appgallery_new.png";
import "./Application.css";
import { useTranslation } from "react-i18next";
const Application = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="container mt50 mb-5">
        <p className="text-uppercase text-center fs-11 pt-5 mb-0 fw-lighter">
          MÜKEMEL
        </p>
        <h3 className="text-center pt-0 pb-5 fw-light">
          {t("MobileApplications")}
        </h3>

        <div className="row text-center justify-content-center">
          <div className="col-lg-4 col-md-5 col-sm-6 mb-5">
            <a
              href="https://apps.apple.com/us/app/m%C3%BCkemel/id6753164005"
              target="_blank"
              rel="noopener noreferrer"
              className="border p-4 rounded-3 d-inline-flex align-items-center justify-content-center"
            >
              <img src={AppStore} alt="App Store" width={200} height={43} />
            </a>
          </div>

          <div className="col-lg-4 col-md-5 col-sm-6 mb-5">
            <a
              href="https://play.google.com/store/apps/details?id=com.murataktas61.mukemelapp"
              target="_blank"
              rel="noopener noreferrer"
              className="border p-4 rounded-3 d-inline-flex align-items-center justify-content-center"
            >
              <img src={PlayStore} alt="Google Play" width={200} height={43} />
            </a>
          </div>

          <div className="col-lg-4 col-md-5 col-sm-6 mb-5">
            <a
              href="https://appgallery.huawei.com/app/C117752099"
              target="_blank"
              rel="noopener noreferrer"
              className="border p-4 rounded-3 d-inline-flex align-items-center justify-content-center gap-2 text-decoration-none"
              style={{ width: "250px" }}
            >
              <img src={AppGallery} alt="App Gallery" width={43} height={43} />
              <span
                className="fw-semibold text-dark"
                style={{ fontSize: "25px", fontWeight: 500 }}
              >
                App Gallery
              </span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Application;
